document.addEventListener('DOMContentLoaded', function(){

    if(window.location.search.includes('customer_posted=true')){

        sessionStorage.setItem('newsletterSuccess','true');

        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        );

    }

    const passwordToggle = document.getElementById('PasswordToggle');
    const passwordDropdown = document.getElementById('PasswordDropdown');

    if(passwordToggle && passwordDropdown){

        passwordToggle.addEventListener('click', function(e){

            e.stopPropagation();

            passwordDropdown.classList.toggle('active');

        });

        document.addEventListener('click', function(e){

            if(
                !passwordDropdown.contains(e.target) &&
                !passwordToggle.contains(e.target)
            ){
                passwordDropdown.classList.remove('active');
            }

        });

    }

    document.querySelectorAll('.global-checkbox--input').forEach((checkbox) => {

        checkbox.addEventListener('change', function(){

            const target = document.querySelector(
                this.dataset.target
            );

            if(!target) return;

            target.disabled = !this.checked;

        });

    });

    const openTerms = document.getElementById('OpenTerms');
    const closeTerms = document.getElementById('CloseTerms');
    const termsModal = document.getElementById('TermsModal');

    if(openTerms && closeTerms && termsModal){

        openTerms.addEventListener('click', function(){

            termsModal.classList.add('active');

        });

        closeTerms.addEventListener('click', function(){

            termsModal.classList.remove('active');

        });

        termsModal.addEventListener('click', function(e){

            if(e.target === termsModal){

                termsModal.classList.remove('active');

            }

        });

    }

    const successPopup = document.getElementById('NewsletterSuccess');

    if(
        successPopup &&
        sessionStorage.getItem('newsletterSuccess') === 'true'
    ){

        successPopup.classList.add('active');

        sessionStorage.removeItem('newsletterSuccess');

    }

    document.querySelectorAll('.newsletter-success-close').forEach((button)=>{

        button.addEventListener('click', function(){

            successPopup.classList.remove('active');

        });

    });

});